import React from "react";

import psi202404 from "../../../../files/price_sensitive_information/psi-(29-04-2024)Related-to-36th-AGM-Dividend-Declaration.pdf";
import psi2023 from "../../../../files/price_sensitive_information/Price-Sensitive-information-1st-Quarterly-Report-2023.pdf";
import psi2023UnAudit from "../../../../files/price_sensitive_information/Price Sensitive Information (Un-Audited 1st Quarterly Report-2023).pdf";
import psi2023Third from "../../../../files/price_sensitive_information/2023-(Related to 3rd Quarterly).pdf";
import psi2023SecondUnAudit from "../../../../files/price_sensitive_information/2023-psi-2nd-quarter.pdf";
import psi2022 from "../../../../files/price_sensitive_information/Price Sensitive Information-2022.pdf";
import psi2021 from "../../../../files/price_sensitive_information/Price Sensitive Information-2021.pdf";
import psi2020 from "../../../../files/price_sensitive_information/Price Sensitive Information 2020.pdf";
import psi2019 from "../../../../files/price_sensitive_information/psi-2019.jpg";
import psi2024FirstQuarter from "../../../../files/price_sensitive_information/Price Sensitive Information Related to 1st Quarter 2024.pdf";
import psi2024SecondQuarter from "../../../../files/price_sensitive_information/Price Sensitive Information-2nd-quarter.pdf";
import psi2024ThirdQuarter from "../../../../files/price_sensitive_information/psi-2024 (Related to 3rd Quarter).pdf";
import psi37thAgm from "../../../../files/price_sensitive_information/Price Sensitive Information Related to 37th AGM.pdf";
import psi2025First from "../../../../files/price_sensitive_information/Rupali PSI2025-1st.pdf";
import psi2025Second from "../../../../files/price_sensitive_information/2025-(Related to 2nd Quarter).pdf";
import psi2025Third from "../../../../files/price_sensitive_information/PSI-3RD-QUARTER.pdf";
import psi2026Agm38 from "../../../../files/price_sensitive_information/PSI-Rupali Insurance (26-04-2026) Related to 38th AGM.pdf";

const PriceSensitiveInfo = () => {
  return (
    <>
      <div className="row mt-5">
        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2026</h3>
            <hr style={{ color: "#bc2642" }} />

            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={psi2026Agm38}>
                  Price Sensitive Information (26-04-2026) Related to 38th AGM
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2025</h3>
            <hr style={{ color: "#bc2642" }} />

            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={psi2025Third}>
                  2025 Related to (3rd Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2025Second}>
                  2025 Related to (2nd Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2025First}>
                  2025 Related to (1st Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi37thAgm}>
                  Price Sensitive Information (26-04-2025) Related to 37th AGM
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2024</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={psi2024ThirdQuarter}>
                  2024 (Related to 3rd Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2024SecondQuarter}>
                  2024 (Related to 2nd Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2024FirstQuarter}>
                  2024 (Related to 1st Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi202404}>
                  Price Sensitive Information (29-04-2024) Related to 36th AGM &
                  Dividend Declaration
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2023</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={psi2023Third}>
                  2023 (Related to 3rd Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2023SecondUnAudit}>
                  2023 (Related to 2nd Quarter){" "}
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2023}>
                  2023 (Related to 1st Quarter)
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2023UnAudit}>
                  2023 Un-Audited 1st Quarterly Report
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="quarter_report_content">
            <h3 className="year_title">2022</h3>
            <hr style={{ color: "#bc2642" }} />
            <ul>
              <li>
                <a target="_blank" rel="noreferrer" href={psi2022}>
                  Price Sensitive Information 2022
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2021}>
                  Price Sensitive Information 2021
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2020}>
                  Price Sensitive Information 2020
                </a>
              </li>

              <li>
                <a target="_blank" rel="noreferrer" href={psi2019}>
                  Price Sensitive Information 2019
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceSensitiveInfo;
